import { Codebook } from '../Codebook'
import {
  ReservationTaskTemplateConditionType,
  ReservationTaskTemplateConditionTypeId,
} from '../reservation-task-template-condition-type/ReservationTaskTemplateConditionType'
import { TaskTemplateTypeId } from '../task-template-type/TaskTemplateType'
import { $t } from '../../composables/i18n'

export type TaskTemplateTriggerTypeId =
  | TaskTemplateTypeId.RECURRING
  | ReservationTaskTemplateConditionTypeId

/**
 * Trigger types identify triggering mechanisms across multiple template types
 *
 * @see TaskTemplateType
 * @see ReservationTaskTemplateConditionType
 */
export class TaskTemplateTriggerType extends Codebook<TaskTemplateTriggerTypeId> {
  // recurring templates only have a single time-based trigger
  static readonly RECURRING = new TaskTemplateTriggerType(TaskTemplateTypeId.RECURRING, () =>
    $t('Recurring'),
  )

  // reservation task templates have different triggers depending on a condition
  static readonly SERVICE = new TaskTemplateTriggerType(
    ReservationTaskTemplateConditionTypeId.SERVICE,
    ReservationTaskTemplateConditionType.SERVICE.name,
  )

  static readonly GUEST_COUNT = new TaskTemplateTriggerType(
    ReservationTaskTemplateConditionTypeId.GUESTS_COUNT,
    ReservationTaskTemplateConditionType.GUESTS_COUNT.name,
  )

  static readonly STAY_LENGTH = new TaskTemplateTriggerType(
    ReservationTaskTemplateConditionTypeId.STAY_LENGTH,
    ReservationTaskTemplateConditionType.STAY_LENGTH.name,
  )

  static readonly ROOM_TYPE = new TaskTemplateTriggerType(
    ReservationTaskTemplateConditionTypeId.ROOM_TYPE,
    ReservationTaskTemplateConditionType.ROOM_TYPE.name,
  )

  static readonly PACKAGE = new TaskTemplateTriggerType(
    ReservationTaskTemplateConditionTypeId.PACKAGE,
    ReservationTaskTemplateConditionType.PACKAGE.name,
  )

  static readonly NUMBER_OF_STAYS = new TaskTemplateTriggerType(
    ReservationTaskTemplateConditionTypeId.NUMBER_OF_STAYS,
    ReservationTaskTemplateConditionType.NUMBER_OF_STAYS.name,
  )

  static readonly GUEST_TAG = new TaskTemplateTriggerType(
    ReservationTaskTemplateConditionTypeId.GUEST_TAG,
    ReservationTaskTemplateConditionType.GUEST_TAG.name,
  )

  private constructor(
    id: TaskTemplateTriggerTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
